import { useQuery } from 'data-fetching-client';
import { GET_OAUTH_URL } from '../queries/oauthUrlQuery';
export function useOAuthUrl({
  offeringId,
  published,
  skip
}) {
  var _oauthUrlData$oauthUr;
  const {
    data: oauthUrlData,
    loading: oauthUrlLoading,
    error: oauthUrlError
  } = useQuery(GET_OAUTH_URL, {
    skip: skip || !offeringId,
    variables: {
      offeringId,
      published
    }
  });
  const oauthUrl = oauthUrlData === null || oauthUrlData === void 0 || (_oauthUrlData$oauthUr = oauthUrlData.oauthUrl) === null || _oauthUrlData$oauthUr === void 0 ? void 0 : _oauthUrlData$oauthUr.oauthUrl;
  return {
    oauthUrl,
    oauthUrlLoading,
    oauthUrlError
  };
}